


















































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import AppForm from '@core/components/AppForm.vue'
import { isUndefined, isNull } from 'lodash/fp'
import { FormStructure } from '@master/model/structure/FormStructure'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { UIService } from '@core/services/UIService'
import { UserMeta } from '@core/model/common/UserMeta'
import { CommissionStructureMeta } from '@core/model/common/CommissionStructureMeta'
import AppDialog from '@core/components/AppDialog.vue'

@Component({
  components: {
    AppForm,
    AppDialog
  }
})
export default class UserCommissionStructure extends Vue {
  @inject()
  private $api: API

  uiService: UIService

  private commissionStructureList: CommissionStructureMeta[] = []

  async fetchCommissionStructure () {
    const res = await this.$api.commissionStructure.getCommissionStructure({ _oid: this.userOid })
    this.commissionStructureList = res.data.map(e => {
      const newCommissionStructure = new CommissionStructureMeta()
      newCommissionStructure.assignData(Object.keys(e), Object.values(e))
      return newCommissionStructure
    })
  }

  private userList: UserMeta[] = []

  get userOid (): string {
    return this.$route.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  get isSuperUser () {
    return this.$store.getters.currentUser.isSuperUser
  }

  private isModalVisible = false;
  private openedModalIndex = null;
  private nameOptions = [];
  private newCommissionStructure: CommissionStructureMeta = new CommissionStructureMeta()

  private errors = [];

  async mounted () {
    await this.getAllUsers()
    await this.fetchCommissionStructure()
  }

  get allLevelAvailable () {
    return this.commissionStructureList.length >= 4
  }

  async getAllUsers () {
    const headers = ['_oid', 'names', 'fullname', 'email']

    const response = await this.$api.account.list({
      groupStatus: 'user',
      headers: JSON.stringify(headers)
    })

    this.userList = response.data.map(e => {
      const user = new UserMeta()
      user.assignData(headers, e)
      return user
    })

    this.nameOptions = this.userList.map(e => {
      return {
        label: e.fullname + ' (' + e.names + ')',
        value: e.oid
      }
    })
  }

  getFullname (receiverOid) {
    if (!receiverOid) return ''
    const user = this.userList.find(e => e.oid === receiverOid)
    return user?.fullname + ' ' + user?.names
  }

  async openModal (index: number | null) {
    this.openedModalIndex = index
    this.isModalVisible = true

    this.newCommissionStructure = new CommissionStructureMeta()
    if (!isNull(index) || isUndefined(index)) {
      this.newCommissionStructure = this.commissionStructureList[index]
    }

    if (index === null) { // null is when user click on `Add New Commission`
      this.newCommissionStructure.receiverOid = this.userOid
      this.newCommissionStructure.level = this.commissionStructureList.length + 1
    }
  }

  get CommissionStructureForm (): FormStructure<CommissionStructureMeta> {
    return [
      {
        label: 'Name',
        key: 'receiverOid',
        options: this.nameOptions,
        disabled: this.newCommissionStructure.level === 1
      },
      {
        label: 'CIS',
        key: 'cisPct',
        type: 'number'
      },
      {
        label: 'GI',
        key: 'giPct',
        type: 'number'
      },
      {
        label: 'GI Renew',
        key: 'giRenewPct',
        type: 'number'
      },
      {
        label: 'EB',
        key: 'ebPct',
        type: 'number'
      },
      {
        label: 'Other Services',
        key: 'otherServicesPct',
        type: 'number'
      },
      {
        label: 'Life',
        key: 'lifePct',
        type: 'number'
      },
      {
        label: 'Loan',
        key: 'loanPct',
        type: 'number'
      },
      {
        label: 'Para Planning',
        key: 'paraPlanningPct',
        type: 'number'
      }
    ]
  }

  async deleteCommission () {
    const isConfirm = await this.uiService.confirm.show({
      type: 'warning',
      message: 'Remove user from the Commission Structure table?'
    })
    if (isConfirm) {
      await this.$api.commissionStructure.deleteCommissionStructure({
        pky: this.newCommissionStructure.pky
      })
      this.isModalVisible = false
      this.commissionStructureList = this.commissionStructureList.filter(e => e.pky !== this.newCommissionStructure.pky)
    }
  }

  validateCommission (): void {
    this.errors = []

    if (
      Number(this.newCommissionStructure.cisPct) > 100 ||
      Number(this.newCommissionStructure.giPct) > 100 ||
      Number(this.newCommissionStructure.giRenewPct) > 100 ||
      Number(this.newCommissionStructure.ebPct) > 100 ||
      Number(this.newCommissionStructure.otherServicesPct) > 100 ||
      Number(this.newCommissionStructure.lifePct) > 100 ||
      Number(this.newCommissionStructure.loanPct) > 100 ||
      Number(this.newCommissionStructure.paraPlanningPct) > 100
    ) {
      this.errors.push('No fields should be above 100%')
    }
    if (this.totalByKey('cisPct', true) > 100) {
      this.errors.push('CIS percentage is more than 100%')
      this.newCommissionStructure.cisPct = null
    }
    if (this.totalByKey('giPct', true) > 100) {
      this.errors.push('GI percentage is more than 100%')
      this.newCommissionStructure.giPct = null
    }
    if (this.totalByKey('giRenewPct', true) > 100) {
      this.errors.push('GI Renew percentage is more than 100%')
      this.newCommissionStructure.giRenewPct = null
    }
    if (this.totalByKey('ebPct', true) > 100) {
      this.errors.push('EB percentage is more than 100%')
      this.newCommissionStructure.ebPct = null
    }
    if (this.totalByKey('otherServicesPct', true) > 100) {
      this.errors.push('Other services percentage is more than 100%')
      this.newCommissionStructure.otherServicesPct = null
    }
    if (this.totalByKey('lifePct', true) > 100) {
      this.errors.push('Life percentage is more than 100%')
      this.newCommissionStructure.lifePct = null
    }
    if (this.totalByKey('loanPct', true) > 100) {
      this.errors.push('Loan percentage is more than 100%')
      this.newCommissionStructure.loanPct = null
    }
    if (this.totalByKey('paraPlanningPct', true) > 100) {
      this.errors.push('Para planning percentage is more than 100%')
      this.newCommissionStructure.paraPlanningPct = null
    }
  }

  async saveCommission () {
    this.validateCommission()
    if (this.errors.length) {
      await this.uiService.alert.show({
        type: 'warning',
        message: this.errors.join('\n')
      })
      return
    }

    await this.$api.commissionStructure.saveCommissionLevel({
      _oid: this.userOid,
      commission_level: this.newCommissionStructure.level,
      data: JSON.stringify(this.newCommissionStructure.convertToRawData())
    })
    await this.fetchCommissionStructure()
    this.isModalVisible = false
  }

  totalByKey (key: keyof CommissionStructureMeta, saveMode: boolean) {
    let total = 0
    if (!this.commissionStructureList) return
    this.commissionStructureList.forEach((commission) => {
      total += Number(commission[key]) ? Number(commission[key]) : 0
    })
    if (saveMode) {
      total += Number(this.newCommissionStructure[key])
        ? Number(this.newCommissionStructure[key])
        : 0
    }
    return total
  }
}
